/**
 * @file        src/pages/flight/CorporateSearchAnalytics.jsx
 * @description Corporate (B2B) twin of Flight Search Analytics.
 *
 *              A separate SCREEN with a fixed audience, not a filter value on the
 *              retail one (CLAUDE.md §9d) — the audience cannot be moved from the
 *              query string, so a shared link cannot cross the boundary either.
 * @author      Kinetika Labs
 * @created     2026-09-22
 * @changelog
 *   - 2026-09-22 Claude — Initial.
 */
import SearchAnalytics from './SearchAnalytics';

export default function CorporateSearchAnalytics() {
  return (
    <SearchAnalytics
      title="Corporate Search Analytics"
      subtitle="Corporate Flight · what business travellers are looking for"
      audience="b2b"
      backTo="/flight/corporate-search-history"
    />
  );
}
